import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

export const MSAC_FINAL_PROTOCOL_REQUEST = 'FETCH_MSAC_FINAL_PROTOCOL_REQUEST';
export const MSAC_FINAL_PROTOCOL_FAILURE = 'FETCH_MSAC_FINAL_PROTOCOL_FAILURE';
export const MSAC_FINAL_PROTOCOL_SUCCESS = 'FETCH_MSAC_FINAL_PROTOCOL_SUCCESS';

/** Download the final MSAC protocol PDF (rendered by the backend). */
export const fetchCompetitionMsacFinalProtocolReport = competition => {
    return function(dispatch) {
        dispatch(fetchRequest());

        return axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_MSAC_FINAL_PROTOCOL, null, {
            params: {competition},
            isBlob: true,
        }))
            .then(transformHttpResponse)
            .then(response => {
                const content = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'] || '';
                const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
                const filename = filenameMatch ? filenameMatch[1] : 'msac_final_protocol.pdf';
                download(response.data, filename, content);
                dispatch(fetchSuccess());
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

/**
 * The same protocol as an Excel workbook — «Зведений протокол» in the
 * federation's «Свод» layout (MsacSummaryProtocolXlsx). Resolves when done.
 */
export const fetchCompetitionMsacFinalProtocolXlsx = competition => dispatch => axios(apiRequestOptions(
    apiPath.REPORTS.COMPETITION_MSAC_FINAL_PROTOCOL_XLSX,
    null,
    { params: { competition }, isBlob: true },
))
    .then(transformHttpResponse)
    .then(response => {
        const contentDisposition = response.headers['content-disposition'] || '';
        const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
        download(
            response.data,
            filenameMatch ? filenameMatch[1] : 'msac_summary_protocol.xlsx',
            response.headers['content-type'],
        );
    })
    .catch(error => transformHttpResponse(error.response))
    .catch(error => dispatch(errorRequestHandler(error)));

const fetchRequest = () => ({type: MSAC_FINAL_PROTOCOL_REQUEST});

const fetchFailure = error => ({type: MSAC_FINAL_PROTOCOL_FAILURE, error,});

const fetchSuccess = () => ({type: MSAC_FINAL_PROTOCOL_SUCCESS});

/**
 * «Звіт керівника делегації» — the Ministry's form for an international
 * competition, filled with what the system knows (MsacDelegationReportXlsx);
 * the rest is typed into the downloaded workbook. Resolves when done.
 */
export const fetchCompetitionMsacDelegationReport = competition => dispatch => axios(apiRequestOptions(
    apiPath.REPORTS.COMPETITION_MSAC_DELEGATION_REPORT,
    null,
    { params: { competition }, isBlob: true },
))
    .then(transformHttpResponse)
    .then(response => {
        const contentDisposition = response.headers['content-disposition'] || '';
        const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
        download(
            response.data,
            filenameMatch ? filenameMatch[1] : 'zvit-kerivnyka-delehatsii.xlsx',
            response.headers['content-type'],
        );
    })
    .catch(error => transformHttpResponse(error.response))
    .catch(error => dispatch(errorRequestHandler(error)));
